export default "__VITE_ASSET__Bd4_kUBi__"